<ndt-tile-view
   [canRefresh]="true"
   [callState]="tile?.callState"
   [isEditing]="isEditing"
   [isFullscreen]="isFullscreen"
   [tileConfig]="tileConfig"
   [showHeader]="showHeader"
   [overrideRefreshTile]="false"
   (configureParameters)="onConfigureParameters()"
   ndtTileContainer
   (refreshTile)="onRefreshTile()"
>
   <p tileheadername>{{ tileConfig.dashboardTileLayoutConfiguration.name }}</p>

   <div tileInfo [ngSwitch]="viewMode">
      <div class="medium">
         <ndt-paged-table-wrapper [dataSource]="phoneQueuesData" [rowHeight]="rowHeight">
            <ng-template #pagedTable let-dataSource="dataSource">
               <table id="phone-queues-table" lcs-table [dataSource]="dataSource">
                  <tr lcs-header-row *lcsHeaderRowDef="columns"></tr>
                  <tr lcs-row *lcsRowDef="let row; columns: columns" [class.calls-waiting]="row.callsWaiting > 0"></tr>

                  <ng-container lcsColumnDef="queueName">
                     <th lcs-header-cell *lcsHeaderCellDef id="queueName-column-header">Queue</th>
                     <td lcs-cell *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.queueName || queue.queueNumber }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="queueNumber">
                     <th lcs-header-cell *lcsHeaderCellDef id="queueNumber-column-header">Extension</th>
                     <td lcs-cell *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.queueNumber }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="callsWaiting">
                     <th lcs-header-cell *lcsHeaderCellDef id="callsWaiting-column-header" class="numeric"
                        >Calls Waiting</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.callsWaiting }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="callsAbandoned">
                     <th lcs-header-cell *lcsHeaderCellDef id="callsAbandoned-column-header" class="numeric"
                        >Calls Abandoned</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.callsAbandoned }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="oldestCall">
                     <th lcs-header-cell *lcsHeaderCellDef id="oldestCall-column-header" class="numeric"
                        >Oldest Call</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.oldestCall ? (queue.oldestCall | formatMinutes) : '-' }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="oldestCallWaiting">
                     <th lcs-header-cell *lcsHeaderCellDef id="oldestCallWaiting-column-header" class="numeric"
                        >Oldest Call Waiting</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.oldestCallWaiting ?? 0 | formatMinutes }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="averageHoldLast30Minutes">
                     <th lcs-header-cell *lcsHeaderCellDef id="averageHoldLast30Minutes-column-header" class="numeric"
                        >Avg Hold (30m)</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.averageHoldLast30Minutes | formatMinutes }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="averageHoldToday">
                     <th lcs-header-cell *lcsHeaderCellDef id="averageHoldToday-column-header" class="numeric"
                        >Avg Hold (Today)</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.averageHoldToday | formatMinutes }}
                        </a>
                     </td>
                  </ng-container>

                  <ng-container lcsColumnDef="loggedInAgents">
                     <th lcs-header-cell *lcsHeaderCellDef id="loggedInAgents-column-header" class="numeric"
                        >Logged In</th
                     >
                     <td lcs-cell class="numeric" *lcsCellDef="let queue">
                        <a [routerLink]="getRouterLink(queue.queueExtensionId)">
                           {{ queue.loggedInAgents }}
                        </a>
                     </td>
                  </ng-container>
               </table>
            </ng-template>
         </ndt-paged-table-wrapper>
      </div>
   </div>

   <ndt-tile-parameters
      [tileConfig]="tileConfig"
      [formService]="formService"
      *ndtTileParametersDef
      tileParametersList
   ></ndt-tile-parameters>
</ndt-tile-view>
